import React from 'react';

const ChartHomeContext = React.createContext('chart');

export const ChartHomeContextProvider = ChartHomeContext.Provider;

export default ChartHomeContext;
